import React, { useState, useEffect } from "react";

export const ErrorBoundary: React.FC = () => {
  const [_, setError] = useState<Error | null>(null);

  useEffect(() => {
    const errorHandler = (event: ErrorEvent) => {
      setError(event.error || new Error(event.message));
      console.error("Caught by ErrorBoundary:", event.error || event.message);
    };

    window.addEventListener("error", errorHandler);
    return () => {
      window.removeEventListener("error", errorHandler);
    };
  }, []);

  return <h1>Something went wrong.</h1>;
};
